import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { getBrowserDefaultLanguage, getBrowserDefaultLocaleKey } from "@faire/retailer-visitor-shared/consts/LANGUAGE";
import { getLocaleKey } from "@faire/retailer-visitor-shared/serialized-data/getLocaleKey";
import { getUser } from "@faire/retailer-visitor-shared/serialized-data/getUser";
import { getRetailerUserNotificationCount } from "@faire/retailer-visitor-shared/serialized-data/retailerUserNotificationCount";
import { DEFAULT_LOCALE_KEY } from "@faire/web--source/common/consts/DEFAULT_LOCALE";
import { SHOP_PREVIEW_OVERRIDE_KEY } from "@faire/web--source/common/consts/SHOP_PREVIEW_OVERRIDE_KEY";
import { localeStringToLocaleKey } from "@faire/web--source/common/consts/TWO_TO_THREE_LETTER_LANGUAGE_CODE";
import { getCookies } from "@faire/web--source/common/cookies";
import { CurrencyStore } from "@faire/web--source/common/currency/CurrencyStore";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { logError } from "@faire/web--source/common/logging";
import { makeObservable } from "@faire/web--source/common/makeObservable";
import { faireBaseUrl } from "@faire/web--source/common/routes/faireBaseUrl";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { createStoreHook } from "@faire/web--source/ui/hooks/useStore";
import getUserAddresses from "@faire/web-api--source/api/retailer/address/list/post";
import getUserAsync from "@faire/web-api--source/api/user/get";
import logout from "@faire/web-api--source/api/user/logout/post";
import { MANAGE_RETAILER_ACCOUNT_USER_PERMISSIONS } from "@faire/web-api--source/faire/session/CapabilityEnum/MANAGE_RETAILER_ACCOUNT_USER_PERMISSIONS";
import { RETAILER_PLACE_ORDER } from "@faire/web-api--source/faire/session/CapabilityEnum/RETAILER_PLACE_ORDER";
import { RETAILER_TRANSFER_OWNERSHIP } from "@faire/web-api--source/faire/session/CapabilityEnum/RETAILER_TRANSFER_OWNERSHIP";
import { IAddress } from "@faire/web-api--source/indigofair/data/IAddress";
import { IListRetailerAddressesRequest } from "@faire/web-api--source/indigofair/data/IListRetailerAddressesRequest";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";
import { IRetailerAccountUserManagement } from "@faire/web-api--source/indigofair/retailer/IRetailerAccountUserManagement";
import { RetailerUserNotificationGroup } from "@faire/web-api--source/indigofair/retailer/RetailerUserNotificationGroup";
import { IWebSocketMessage } from "@faire/web-api--source/indigofair/websockets/IWebSocketMessage";
import { action, computed, observable } from "mobx";
/**
 * @deprecated prefer to use `useUserStore` or `withStores` instead
 */ export var UserStore = /*#__PURE__*/ function() {
    "use strict";
    function UserStore() {
        var _this = this;
        _class_call_check(this, UserStore);
        var _this1 = this;
        this.userAddresses = [];
        this.addressDeletableMap = {};
        this.user = getUser();
        this.fetchUserAddresses = /*#__PURE__*/ _async_to_generator(function() {
            var addresses, _addresses_addresses, _addresses_addresses1, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this1.user) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            getUserAddresses(IListRetailerAddressesRequest.build({}))
                        ];
                    case 2:
                        addresses = _state.sent();
                        if (!addresses) {
                            return [
                                2
                            ];
                        }
                        _this1.userAddresses = ((_addresses_addresses = addresses.addresses) !== null && _addresses_addresses !== void 0 ? _addresses_addresses : []).map(function(address) {
                            return address.address;
                        }).filter(isNotUndefined);
                        _this1.addressDeletableMap = ((_addresses_addresses1 = addresses.addresses) !== null && _addresses_addresses1 !== void 0 ? _addresses_addresses1 : []).reduce(function(acc, address) {
                            var _address_address;
                            if (!((_address_address = address.address) === null || _address_address === void 0 ? void 0 : _address_address.token)) {
                                return acc;
                            }
                            return _object_spread_props(_object_spread({}, acc), _define_property({}, address.address.token, !!address.is_deletable));
                        }, {});
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        logError(e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        this.retailerUserNotificationCount = getRetailerUserNotificationCount();
        this.fetchUser = /*#__PURE__*/ _async_to_generator(function() {
            var _;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = _this1.setUser;
                        return [
                            4,
                            getUserAsync()
                        ];
                    case 1:
                        _.apply(_this1, [
                            _state.sent()
                        ]);
                        _this1.fetchUserAddresses();
                        return [
                            2
                        ];
                }
            });
        });
        this.setUser = function(user) {
            if (!_this.user || user && user.version >= _this.user.version) {
                _this.user = user;
            }
        };
        /**
         * patch the frontend user. Provided user partial will be used to update this.user
         * @param user partial to be applied on top of existing user
         */ this.patchUser = function(user) {
            _this.setUser(IUser.build(_object_spread({}, _this.user, user)));
        };
        this.logOut = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(dest) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                logout()
                            ];
                        case 1:
                            _state.sent();
                            CurrencyStore.get().setCurrency(undefined);
                            getLocationOrThrow().href = dest ? dest : faireBaseUrl();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(dest) {
                return _ref.apply(this, arguments);
            };
        }();
        this.handleRetailerUserNotificationChannelMessage = function(message) {
            if (message.type === IWebSocketMessage.Type.RETAILER_USER_NOTIFICATION_COUNT_UPDATED && !!message.retailer_user_notification_count) {
                _this.retailerUserNotificationCount = message.retailer_user_notification_count;
            }
        };
        this.userHasSufficientCapability = function(capability) {
            return _this.userCapabilities.includes(capability);
        };
        this.addressIsDeletable = function(addressToken) {
            if (!addressToken) {
                return false;
            }
            return !!_this.addressDeletableMap[addressToken];
        };
        makeObservable(this);
        this.fetchUserAddresses();
    }
    _create_class(UserStore, [
        {
            key: "userToken",
            get: function get() {
                var _this_user;
                var _this_user_token;
                return (_this_user_token = (_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.token) !== null && _this_user_token !== void 0 ? _this_user_token : "";
            }
        },
        {
            key: "fullName",
            get: function get() {
                if (!this.firstName || !this.lastName) {
                    return "";
                }
                return [
                    this.firstName,
                    this.lastName
                ].join(" ").trim();
            }
        },
        {
            key: "firstName",
            get: function get() {
                var _this_user;
                var _this_user_first_name;
                return (_this_user_first_name = (_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.first_name) !== null && _this_user_first_name !== void 0 ? _this_user_first_name : "";
            }
        },
        {
            key: "lastName",
            get: function get() {
                var _this_user;
                var _this_user_last_name;
                return (_this_user_last_name = (_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.last_name) !== null && _this_user_last_name !== void 0 ? _this_user_last_name : "";
            }
        },
        {
            key: "emailAddress",
            get: function get() {
                var _this_user;
                return (_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.email_address;
            }
        },
        {
            key: "phoneNumber",
            get: function get() {
                var _this_user;
                return (_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.phone_number;
            }
        },
        {
            key: "addresses",
            get: function get() {
                var _this_userAddresses;
                return (_this_userAddresses = this.userAddresses) !== null && _this_userAddresses !== void 0 ? _this_userAddresses : [];
            }
        },
        {
            key: "defaultAddress",
            get: function get() {
                var _this_user;
                var _this_user_default_shipping_address;
                return (_this_user_default_shipping_address = (_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.default_shipping_address) !== null && _this_user_default_shipping_address !== void 0 ? _this_user_default_shipping_address : IAddress.build();
            }
        },
        {
            key: "isEmployee",
            get: function get() {
                var _this_user;
                return !!((_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.is_employee);
            }
        },
        {
            key: "isImpersonating",
            get: function get() {
                var _this_user;
                return !!((_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.impersonating);
            }
        },
        {
            key: "userLocale",
            get: // userLocale is used for preferred communication language
            function get() {
                var _this_user_locale_key, _this_user;
                var _this_user_locale_key_language, _ref;
                return (_ref = (_this_user_locale_key_language = (_this_user = this.user) === null || _this_user === void 0 ? void 0 : (_this_user_locale_key = _this_user.locale_key) === null || _this_user_locale_key === void 0 ? void 0 : _this_user_locale_key.language) !== null && _this_user_locale_key_language !== void 0 ? _this_user_locale_key_language : getBrowserDefaultLanguage()) !== null && _ref !== void 0 ? _ref : DEFAULT_LOCALE_KEY.language;
            }
        },
        {
            key: "browserLevelLanguage",
            get: // browserLevelLanguage is only for browsing purpose. It doesn't save language in database
            // It's is different from preferred communication language.
            function get() {
                var _getLocaleKey;
                var _getLocaleKey_language;
                return (_getLocaleKey_language = (_getLocaleKey = getLocaleKey()) === null || _getLocaleKey === void 0 ? void 0 : _getLocaleKey.language) !== null && _getLocaleKey_language !== void 0 ? _getLocaleKey_language : this.userLocale;
            }
        },
        {
            key: "userLocaleKey",
            get: function get() {
                var _this_user;
                var _this_user_locale_key, _ref;
                return (_ref = (_this_user_locale_key = (_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.locale_key) !== null && _this_user_locale_key !== void 0 ? _this_user_locale_key : getBrowserDefaultLocaleKey()) !== null && _ref !== void 0 ? _ref : DEFAULT_LOCALE_KEY;
            }
        },
        {
            key: "browserLevelLocaleKey",
            get: function get() {
                var _getLocaleKey;
                return (_getLocaleKey = getLocaleKey()) !== null && _getLocaleKey !== void 0 ? _getLocaleKey : this.userLocaleKey;
            }
        },
        {
            key: "browserLevelLocaleOverride",
            get: function get() {
                var overrideLanguage = getCookies(SHOP_PREVIEW_OVERRIDE_KEY);
                if (!overrideLanguage || !localeStringToLocaleKey(overrideLanguage).language) {
                    return undefined;
                }
                return localeStringToLocaleKey(overrideLanguage);
            }
        },
        {
            key: "hasFaireEmailAddress",
            get: function get() {
                var _this_emailAddress;
                return !!((_this_emailAddress = this.emailAddress) === null || _this_emailAddress === void 0 ? void 0 : _this_emailAddress.endsWith("@faire.com"));
            }
        },
        {
            key: "isRetailerSubUser",
            get: function get() {
                return !this.userHasSufficientCapability(RETAILER_TRANSFER_OWNERSHIP);
            }
        },
        {
            key: "isOwnerUser",
            get: function get() {
                return this.userHasSufficientCapability(RETAILER_TRANSFER_OWNERSHIP);
            }
        },
        {
            key: "accountType",
            get: function get() {
                if (!this.isRetailerSubUser) {
                    return IRetailerAccountUserManagement.Role.OWNER;
                }
                return this.userHasSufficientCapability(MANAGE_RETAILER_ACCOUNT_USER_PERMISSIONS) ? IRetailerAccountUserManagement.Role.ADMIN : IRetailerAccountUserManagement.Role.CONTRIBUTOR;
            }
        },
        {
            key: "userCapabilities",
            get: function get() {
                var _this_user;
                var _this_user_capabilities;
                return (_this_user_capabilities = (_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.capabilities) !== null && _this_user_capabilities !== void 0 ? _this_user_capabilities : [];
            }
        },
        {
            key: "userCanPlaceOrder",
            get: function get() {
                return this.userCapabilities.includes(RETAILER_PLACE_ORDER);
            }
        },
        {
            key: "userProfileImage",
            get: function get() {
                var _this_user;
                return (_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.profile_image;
            }
        },
        {
            key: "isBrandUser",
            get: function get() {
                var _this_user;
                return ((_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.type) === IUser.Type.BRAND_USER;
            }
        },
        {
            key: "isAdminUser",
            get: function get() {
                var _this_user;
                return ((_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.type) === IUser.Type.ADMIN;
            }
        },
        {
            key: "myTeamNotificationCount",
            get: function get() {
                var _this_retailerUserNotificationCount_un_dismissed_notifications_count_by_group_find, _this_retailerUserNotificationCount_un_dismissed_notifications_count_by_group, _this_retailerUserNotificationCount;
                var _this_retailerUserNotificationCount_un_dismissed_notifications_count_by_group_find_count;
                return (_this_retailerUserNotificationCount_un_dismissed_notifications_count_by_group_find_count = (_this_retailerUserNotificationCount = this.retailerUserNotificationCount) === null || _this_retailerUserNotificationCount === void 0 ? void 0 : (_this_retailerUserNotificationCount_un_dismissed_notifications_count_by_group = _this_retailerUserNotificationCount.un_dismissed_notifications_count_by_group) === null || _this_retailerUserNotificationCount_un_dismissed_notifications_count_by_group === void 0 ? void 0 : (_this_retailerUserNotificationCount_un_dismissed_notifications_count_by_group_find = _this_retailerUserNotificationCount_un_dismissed_notifications_count_by_group.find(function(group) {
                    return group.group === RetailerUserNotificationGroup.TEAM_COMMUNICATION;
                })) === null || _this_retailerUserNotificationCount_un_dismissed_notifications_count_by_group_find === void 0 ? void 0 : _this_retailerUserNotificationCount_un_dismissed_notifications_count_by_group_find.count) !== null && _this_retailerUserNotificationCount_un_dismissed_notifications_count_by_group_find_count !== void 0 ? _this_retailerUserNotificationCount_un_dismissed_notifications_count_by_group_find_count : 0;
            }
        },
        {
            key: "notificationUpdateState",
            get: function get() {
                var _this_retailerUserNotificationCount, _this_retailerUserNotificationCount1;
                return {
                    latestStatusUpdate: (_this_retailerUserNotificationCount = this.retailerUserNotificationCount) === null || _this_retailerUserNotificationCount === void 0 ? void 0 : _this_retailerUserNotificationCount.latest_status_update,
                    unviewedActiveNotificationCount: (_this_retailerUserNotificationCount1 = this.retailerUserNotificationCount) === null || _this_retailerUserNotificationCount1 === void 0 ? void 0 : _this_retailerUserNotificationCount1.unviewed_active_notification_count
                };
            }
        }
    ]);
    return UserStore;
}();
UserStore.get = singletonGetter(UserStore);
__decorate([
    observable
], UserStore.prototype, "userAddresses", void 0);
__decorate([
    observable
], UserStore.prototype, "addressDeletableMap", void 0);
__decorate([
    observable
], UserStore.prototype, "user", void 0);
__decorate([
    observable
], UserStore.prototype, "retailerUserNotificationCount", void 0);
__decorate([
    action
], UserStore.prototype, "setUser", void 0);
__decorate([
    computed
], UserStore.prototype, "userToken", null);
__decorate([
    computed
], UserStore.prototype, "fullName", null);
__decorate([
    computed
], UserStore.prototype, "firstName", null);
__decorate([
    computed
], UserStore.prototype, "lastName", null);
__decorate([
    computed
], UserStore.prototype, "emailAddress", null);
__decorate([
    computed
], UserStore.prototype, "phoneNumber", null);
__decorate([
    computed
], UserStore.prototype, "addresses", null);
__decorate([
    computed
], UserStore.prototype, "defaultAddress", null);
__decorate([
    computed
], UserStore.prototype, "isEmployee", null);
__decorate([
    computed
], UserStore.prototype, "isImpersonating", null);
__decorate([
    computed
], UserStore.prototype, "userLocale", null);
__decorate([
    computed
], UserStore.prototype, "browserLevelLanguage", null);
__decorate([
    computed
], UserStore.prototype, "userLocaleKey", null);
__decorate([
    computed
], UserStore.prototype, "browserLevelLocaleKey", null);
__decorate([
    computed
], UserStore.prototype, "browserLevelLocaleOverride", null);
__decorate([
    computed
], UserStore.prototype, "hasFaireEmailAddress", null);
__decorate([
    computed
], UserStore.prototype, "isRetailerSubUser", null);
__decorate([
    computed
], UserStore.prototype, "isOwnerUser", null);
__decorate([
    computed
], UserStore.prototype, "accountType", null);
__decorate([
    computed
], UserStore.prototype, "userCapabilities", null);
__decorate([
    computed
], UserStore.prototype, "userCanPlaceOrder", null);
__decorate([
    computed
], UserStore.prototype, "userProfileImage", null);
__decorate([
    computed
], UserStore.prototype, "isBrandUser", null);
__decorate([
    computed
], UserStore.prototype, "isAdminUser", null);
__decorate([
    computed
], UserStore.prototype, "myTeamNotificationCount", null);
__decorate([
    computed
], UserStore.prototype, "notificationUpdateState", null);
/**
 * @deprecated
 * Use useUserStoreV2 instead.
 * You can also create custom hooks that use `useUser` to access user information.
 */ export var useUserStore = createStoreHook(UserStore);
